import styled from 'styled-components';
import { media } from '@quiqupltd/qu-react-sdk/lib/styles/mixins/media';
import { pxToRem } from '@quiqupltd/qu-react-sdk/lib/utils/styles';
import QuIcon from '@quiqupltd/qu-react-sdk/lib/components/qu-icon';

export const Container = styled.div`
  flex: 1;
  padding: 0 16px 24px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  ${media.up('phone')`
    padding: 0 48px 36px;
    height: 124px;
  `};
`;

export const WaypointWrapper = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid ${props => props.theme.greyLight};
`;

export const WaypointText = styled.span`
  font-size: ${pxToRem(16)};
  font-weight: 300;
  line-height: 1.25;
  margin: 0;
`;

export const Icon = styled(QuIcon)`
  margin-right: 4px;
  top: ${props => (props.type === 'pickup' ? '2px' : '1px')};
  position: relative;
  color: ${props => props.theme.sky500};

  svg {
    fill: #fff;
  }
`;



// WEBPACK FOOTER //
// ./src/app/order-card/delivery-failed/body/delivery-failed-body.styles.js